import { defineComponent, h } from 'vue';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../Shared/utils.jsx';

const HiddenContainer = defineComponent({
    name: 'hidden-container',
    mixins: [BaseComponent],
    data: function () {
        return {
        }
    },
    //Mounted Replaced with preRenderComplete
    computed: {
    },
    methods: {
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
    },
    props: {
    },
    render() {
        return null;
    }
});

export default defineComponent({
    name: 'DynamicControlContainer',
    mixins: [BaseComponent],
    components: {
        HiddenContainer
    },
    data: function () {
        return {
            isbase: false,
            controldataexpr: null,
            internalobjectId: utils.generateUUID(),

            actiondataexpr: null,
        }
    },
    created() {
        this.isbase = this.controlData.IsBase;

        if (this.controlData.Content) {
            this.controldataexpr = utils.compileObject(this, this.controlData.Content);
        }

        if (this.controlData.ActionData) {
            this.actiondataexpr = utils.compileObject(this, this.controlData.ActionData);
        }
    },
    unmounted() {
        if (this.watcher$)
            this.watcher$();
    },
    mounted() {
    },
    props: {
        // Required so SFC `:source-data` / JSX `sourceData={...}` is available to SourceData()
        sourceData: { default: null },
    },
    computed: {
        controldatavalue: function () {
            if (this.controldataexpr) {
                try {
                    const obj = utils.evaluateObject(this.controldataexpr, this);

                    if (obj && !obj.$objectId)
                        obj.$objectId = utils.generateUUID();

                    return obj;
                }
                catch (err) {
                    console.warn(`controldataexpr:${this.controldataexpr.code} - ${err.message}`);
                    return null;
                }
            }
            else
                return null;
        },
        paramData: function () {
            return this.actiondataexpr ? utils.evaluateObject(this.actiondataexpr, this) : null;
        },
        objectId: function () {
            return `${this.internalobjectId}_${this.controldatavalue?.$objectId}`;
        },
    },
    methods: {
        async preRenderComplete() {
            //if (!this.todisplay || !this.controldatavalue)
            //    this.finishRenderHandler(this);
        },
    },
    render() {
        if (!this.todisplay || !this.controldatavalue)
            return null;

        let Tag = utils.dynamicComponents['stack-vertical'];
        if (!this.isvisible)
            Tag = HiddenContainer;

        return (
            <Tag
                key={this.objectId}
                type={this.controlData.ContainerType || 'VerticalStack'}
                onFinishedRender={(reference) => this.finishRenderHandler(reference)}
                class={{ 'c-DynamicControlContainer': true, [`c-name-${this.name || 'unnamed'}`]: true }}
                style={{ flexGrow: "1", flexShrink: "unset" }}
                asbase={this.isbase}
                name={this.controldatavalue.Name}
                root={this.root}
                parentType={this.parentType}
                scopeitems={this.scopeitems}
                controlscope={this.controlscope}
                sourceData={this.sourceData}
                controlData={this.controldatavalue}>
            </Tag>
        );
    }
});